module.exports = __webpack_public_path__ + "static/media/rubl_icon.53961bee.svg";